// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9jHkC","top":"styles_top__10r4p","left":"styles_left__TaoFY","description":"styles_description__1eyUX"};